<mat-menu #menuCustomerVoice="matMenu">
  <div class="review-menu" *ngIf="customerVoiceAppInfo$ | async as brandingInfo">
    <ng-container [ngSwitch]="(cvPreferredSitesSettingsLink$ | async) !== null">
      <ng-container
        *ngSwitchCase="true"
        [ngTemplateOutlet]="reviewLinks"
        [ngTemplateOutletContext]="{ cvBrandingInfo: brandingInfo }"
      ></ng-container>
      <ng-container
        *ngSwitchCase="false"
        [ngTemplateOutlet]="errorState"
        [ngTemplateOutletContext]="{ cvBrandingInfo: brandingInfo }"
      ></ng-container>
    </ng-container>
  </div>
</mat-menu>

<mat-menu #menuContactUs="matMenu">
  <div class="review-menu">
    <div class="mat-menu-item menu-title">
      <img [src]="(customerVoiceAppInfo$ | async)?.iconUrl" class="message-customer-voice-image" />
      {{ 'INBOX.CHAT.INSERT_REVIEW_LINK' | translate }}
    </div>
    <div
      *ngIf="(enableMessagePartnerFeature$ | async) === true; else emptyInsertLink"
      class="message-insert-link-empty"
    >
      <span class="message-insert-link-empty-text">
        {{ 'INBOX.CHAT.GET_ACCESS_TO_REVIEW_LINKS' | translate }}
      </span>
      <button mat-flat-button color="primary" (click)="sendMessage()">
        {{ 'INBOX.CHAT.CONTACT_US' | translate }}
      </button>
    </div>
  </div>
</mat-menu>
<ng-template #emptyInsertLink>
  <div class="message-insert-link-empty">
    <span class="message-insert-link-empty-text">
      {{ 'INBOX.CHAT.GET_ACCESS_TO_REVIEW_LINKS_CONTACT_US' | translate }}
    </span>
  </div>
</ng-template>

<ng-template #reviewLinks let-cvBrandingInfo="cvBrandingInfo">
  <ng-container *ngIf="cvPreferredSitesSettingsLink$ | async as preferredSitesLink; else errorState">
    <div class="mat-menu-item menu-title include-link">
      <div class="message-insert-link-icon-text">
        <img [src]="cvBrandingInfo?.iconUrl" class="message-customer-voice-image" />
        {{ 'INBOX.CHAT.INSERT_REVIEW_LINK' | translate }}
      </div>
      <a class="material-icons open-in-new" [href]="preferredSitesLink" target="_blank">open_in_new</a>
    </div>
    <glxy-loading-spinner *ngIf="loading$ | async"></glxy-loading-spinner>
    <ng-container *ngIf="reviewLinks$ | async as reviewLinks">
      <ng-container *ngIf="(loading$ | async) === false">
        <ng-container *ngIf="reviewLinks?.length > 0; else setupCustomerVoice">
          <button *ngFor="let reviewLink of reviewLinks" mat-menu-item (click)="useLink(reviewLink)">
            {{ reviewLink.sourceName }}
          </button>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #setupCustomerVoice>
      <div class="message-insert-link-empty">
        <span class="message-insert-link-empty-text">
          {{ 'INBOX.CHAT.NO_REVIEW_LINKS_FOUND' | translate : { cvWhiteLabelName: cvBrandingInfo.name } }}
        </span>
        <button mat-flat-button color="primary" (click)="openNewCVPreferredSitesSettingsTab(preferredSitesLink)">
          {{ 'INBOX.CHAT.SETUP_REVIEW_LINKS' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-container>
</ng-template>

<ng-template #errorState let-cvBrandingInfo="cvBrandingInfo">
  <div class="mat-menu-item menu-title include-link">
    <div class="message-insert-link-icon-text">
      <img [src]="cvBrandingInfo?.iconUrl" class="message-customer-voice-image" />
      {{ 'INBOX.CHAT.INSERT_REVIEW_LINK' | translate }}
    </div>
  </div>
  <div class="message-insert-link-empty">
    <span class="message-insert-link-empty-text">
      {{ 'INBOX.CHAT.GET_ACCESS_TO_REVIEW_LINKS_ERROR' | translate }}
    </span>
  </div>
</ng-template>
